import React, { useEffect, useState } from 'react';

const rs = (n) => '₹' + (Number(n) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const q = (n) => { const v = Number(n) || 0; return Number.isInteger(v) ? String(v) : String(Math.round(v * 1000) / 1000); };

const btn = { display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 16px', borderRadius: 12, border: '1px solid #e4e2f3', background: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#1f1d2b' };
const pill = { background: '#f1f0fb', color: '#5b45e0', borderRadius: 999, padding: '2px 9px', fontSize: 12.5, fontWeight: 600 };

export default function ShiftSide({ free = [], products = [] }) {
  const [open, setOpen] = useState(null); // 'top' | 'free' | null
  useEffect(() => {
    const k = (e) => { if (e.key === 'Escape') setOpen(null); };
    window.addEventListener('keydown', k); return () => window.removeEventListener('keydown', k);
  }, []);

  const sold = [...products].filter((p) => (Number(p.amount) || 0) > 0 || (Number(p.free_qty) || 0) > 0).sort((a, b) => (b.amount || 0) - (a.amount || 0));
  const max = sold.length ? Number(sold[0].amount) || 1 : 1;
  const freeQty = free.reduce((s, x) => s + (Number(x.qty) || 0), 0);
  const freeVal = free.reduce((s, x) => s + (Number(x.value) || 0), 0);

  return (
    <>
      <div className="sh-popbtns" style={{ display: 'flex', gap: 10, flexWrap: 'wrap', margin: '0 0 12px' }}>
        <button type="button" style={btn} onClick={() => setOpen('top')}>
          🏆 Item-wise sales <span style={pill}>{sold.length} items</span> ▾
        </button>
        <button type="button" style={{ ...btn, ...(free.length ? { background: '#fffbeb', borderColor: '#fde68a' } : { color: '#9ca3af' }) }}
          onClick={() => free.length && setOpen('free')} disabled={!free.length}>
          🎁 Free items (offers) {free.length ? <span style={{ ...pill, background: '#fef3c7', color: '#92400e' }}>{q(freeQty)} pcs · {rs(freeVal)}</span> : '— none'} {free.length ? '▾' : ''}
        </button>
      </div>

      {open && (
        <div className="sh-pop" onClick={() => setOpen(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(17,16,30,.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div onClick={(e) => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 18, width: 'min(600px, 100%)', maxHeight: '82vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,.25)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #f0eff7' }}>
              <div style={{ fontWeight: 700, fontSize: 17 }}>
                {open === 'top' ? '🏆 Item-wise sales this shift' : `🎁 Free items (offers) — ${q(freeQty)} pcs, worth ${rs(freeVal)}`}
              </div>
              <button type="button" onClick={() => setOpen(null)} style={{ border: 0, background: '#f3f4f6', borderRadius: 8, width: 32, height: 32, cursor: 'pointer', fontSize: 16 }}>✕</button>
            </div>
            <div style={{ overflowY: 'auto', padding: '6px 20px 18px' }}>
              {open === 'top' && sold.map((p, i) => (
                <div key={p.product_id || p.name} style={{ padding: '9px 0', borderBottom: '1px dashed #eee' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, gap: 8 }}>
                    <span>{i + 1}. {p.name} <span style={{ color: '#6b7280' }}>× {q(p.qty)}{p.free_qty ? ` + ${q(p.free_qty)} free` : ''}</span></span>
                    <strong>{rs(p.amount)}</strong>
                  </div>
                  <div style={{ height: 5, background: '#f1f0fb', borderRadius: 4, marginTop: 5 }}>
                    <div style={{ height: 5, width: `${Math.max(2, ((Number(p.amount) || 0) / max) * 100)}%`, background: '#7c5cff', borderRadius: 4 }} />
                  </div>
                </div>
              ))}
              {open === 'free' && (
                <table style={{ width: '100%', fontSize: 14, borderCollapse: 'collapse', marginTop: 6 }}>
                  <thead>
                    <tr style={{ color: '#6b7280', textAlign: 'left' }}>
                      <th style={{ padding: '6px 0', fontWeight: 500 }}>Item</th>
                      <th style={{ textAlign: 'right', fontWeight: 500 }}>Qty</th>
                      <th style={{ textAlign: 'right', fontWeight: 500 }}>Bills</th>
                      <th style={{ textAlign: 'right', fontWeight: 500 }}>Value (MRP)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {free.map((x) => (
                      <tr key={x.product_id} style={{ borderTop: '1px dashed #eee' }}>
                        <td style={{ padding: '8px 0' }}>{x.name}</td>
                        <td style={{ textAlign: 'right' }}>× {q(x.qty)}</td>
                        <td style={{ textAlign: 'right' }}>{x.bills || ''}</td>
                        <td style={{ textAlign: 'right' }}>{rs(x.value)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
